import { render, staticRenderFns } from "./UserQuestionTambah.vue?vue&type=template&id=6f59a6e6&scoped=true"
import script from "./UserQuestionTambah.vue?vue&type=script&lang=js"
export * from "./UserQuestionTambah.vue?vue&type=script&lang=js"
import style0 from "./UserQuestionTambah.vue?vue&type=style&index=0&id=6f59a6e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f59a6e6",
  null
  
)

export default component.exports